function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
// +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2021 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------
import { MessageBox } from 'element-ui';
import request from '@/utils/request';

/**
 * 商品标签 keyword
 */
export function getLabelApi(params) {
  return request({
    url: "/admin/merchant/label/autoList",
    method: 'GET',
    params: params
  });
}

/**
 * 品牌 keyword
 */
export function getBrandrApi(params) {
  return request({
    url: "/admin/store/brand/autoList",
    method: 'GET',
    params: params
  });
}

/**
 * 供应商
 */
export function getSupplierApi(params) {
  return request({
    url: "/admin/business/supplier/autoList",
    method: 'GET',
    params: params
  });
}

/**
 * 产地
 */
export function getCityApi() {
  return request({
    url: "/admin/system/city/list/treeLevel3",
    method: 'GET'
  });
}

/**
 * 新增商品
 * @param pram
 */
export function productCreateApi(data) {
  return request({
    url: '/admin/store/product/save',
    method: 'POST',
    data: data
  });
}

/**
 * 新增商品 - 供应商
 * @param pram
 */
export function productCreateSupplierApi(data) {
  return request({
    url: '/admin/supplier/product/save',
    method: 'POST',
    data: data
  });
}

/**
 * 编辑商品
 * @param pram
 */
export function productUpdateApi(data) {
  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return request({
    url: '/admin/store/product/update',
    method: 'POST',
    data: data,
    params: params
  });
}

/**
 * 编辑商品 - 供应商
 * @param pram
 */
export function productUpdateSupplierApi(data) {
  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return request({
    url: '/admin/supplier/product/update',
    method: 'POST',
    data: data,
    params: params
  });
}

/**
 * 商品详情
 * @param pram
 */
export function productDetailApi(id) {
  return request({
    url: "/admin/store/product/info/".concat(id),
    method: 'GET'
  });
}

/**
 * 商品详情-供应商
 * @param pram
 */
export function productDetailApi2(id) {
  return request({
    url: "/admin/supplier/product/info/".concat(id),
    method: 'GET'
  });
}

/**
 * 删除商品
 * @param pram
 */
export function productDeleteApi(id, type) {
  return request({
    url: "/admin/store/product/delete/".concat(id),
    method: 'get',
    params: {
      type: type
    }
  });
}

/**
 * 商品列表 表头数量
 */
export function productHeadersApi() {
  return request({
    url: '/admin/store/product/tabs/headers',
    method: 'GET'
  });
}

/**
 * 商品列表
 * @param pram
 */
export function productLstApi() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var params = _objectSpread({}, data);
  if (params.showCateId) {
    params.showCateId = params.showCateId.join(',');
  }
  var _ref = data.dateRange || [],
    _ref2 = _slicedToArray(_ref, 2),
    startTime = _ref2[0],
    endTime = _ref2[1];
  if (startTime && endTime) {
    params['startTime'] = startTime;
    params['endTime'] = endTime;
  }
  ;
  delete params.dateRange;
  return request({
    url: '/admin/store/product/list',
    method: 'GET',
    params: params
  });
}

/**
 * 商品列表-供应商
 * @param pram
 */
export function productLstApiSupplier() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var params = _objectSpread({}, data);
  if (params.showCateId) {
    params.showCateId = params.showCateId.join(',');
  }
  var _ref3 = data.dateRange || [],
    _ref4 = _slicedToArray(_ref3, 2),
    startTime = _ref4[0],
    endTime = _ref4[1];
  if (startTime && endTime) {
    params['startTime'] = startTime;
    params['endTime'] = endTime;
  }
  ;
  delete params.dateRange;
  return request({
    // url: '/admin/store/product/list',
    url: '/admin/supplier/product/list',
    method: 'GET',
    params: params
  });
}

/**
 * 商品分类
 * @param pram
 */
export function categoryApi(params) {
  return request({
    url: '/admin/category/list/tree',
    method: 'GET',
    params: params
  });
}
/**
 * 商品上架
 * @param pram
 */
export function putOnShellApi(id) {
  return request({
    url: "/admin/store/product/putOnShell/".concat(id),
    method: 'GET'
  });
}

/**
 * 商品上架 - 供应商
 * @param pram
 */
export function putOnShellApi2(id) {
  return request({
    url: "/admin/supplier/product/putOnShell/".concat(id),
    method: 'GET'
  });
}
/**
 * 商品下架
 * @param pram
 */
export function offShellApi(id) {
  return request({
    url: "/admin/store/product/offShell/".concat(id),
    method: 'GET'
  });
}

/**
 * 商品下架 - 供应商
 * @param pram
 */
export function offShellApi2(id) {
  return request({
    url: "/admin/supplier/product/offShell/".concat(id),
    method: 'GET'
  });
}
/**
 * 商品规格 列表
 * @param pram
 */
export function templateListApi(params) {
  return request({
    url: '/admin/store/product/rule/list',
    method: 'GET',
    params: params
  });
}
/**
 * 商品规格 删除
 * @param pram
 */
export function attrDeleteApi(id) {
  return request({
    url: "/admin/store/product/rule/delete/".concat(id),
    method: 'get'
  });
}
/**
 * 商品规格 新增
 * @param pram
 */
export function attrCreatApi(data) {
  return request({
    url: '/admin/store/product/rule/save',
    method: 'POST',
    data: data
  });
}
/**
 * 商品规格 编辑
 * @param pram
 */
export function attrEditApi(data) {
  return request({
    url: '/admin/store/product/rule/update',
    method: 'POST',
    data: data
  });
}
/**
 * 商品规格 详情
 * @param pram
 */
export function attrInfoApi(id) {
  return request({
    url: "admin/store/product/rule/info/".concat(id),
    method: 'GET'
  });
}
/**
 * 商品评论 列表
 * @param pram
 */
export function replyListApi(params) {
  return request({
    url: '/admin/store/product/reply/list',
    method: 'GET',
    params: params
  });
}
/**
 * 商品评论 新增
 * @param pram
 */
export function replyCreatApi(data) {
  return request({
    url: '/admin/store/product/reply/save',
    method: 'POST',
    data: data
  });
}
/**
 * 商品评论 编辑
 * @param pram
 */
export function replyEditApi(data) {
  return request({
    url: '/admin/store/product/reply/update',
    method: 'POST',
    data: data
  });
}
/**
 * 商品评论 详情
 * @param pram
 */
export function replyInfoApi(id) {
  return request({
    url: "/admin/store/product/reply/info/".concat(id),
    method: 'GET'
  });
}
/**
 * 商品评论 删除
 * @param pram
 */
export function replyDeleteApi(id) {
  return request({
    url: "/admin/store/product/reply/delete/".concat(id),
    method: 'GET'
  });
}

/**
 * 商品评论 回复
 * @param pram
 */
export function replyCommentApi(data) {
  return request({
    url: "/admin/store/product/reply/comment",
    method: 'post',
    data: data
  });
}

/**
 * 商品评论 导出
 * @param pram
 */
export function productExportApi() {
  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var data = _objectSpread({}, params);
  if (data.showCateId) {
    data.showCateId = data.showCateId.join(',');
  }
  ;
  return request({
    url: "/admin/export/excel/product",
    method: 'get',
    params: data
  });
}

/**
 * 商品复制 99Api
 * @param pram
 */
export function importProductApi(params) {
  return request({
    url: "/admin/store/product/importProduct",
    method: 'post',
    params: params
  });
}

/**
 * 商品复制 一号通
 * @param pram
 */
export function copyProductApi(data) {
  return request({
    url: "/admin/store/product/copy/product",
    method: 'post',
    data: data
  });
}

/**
 * 恢复
 * @param pram
 */
export function restoreApi(id) {
  return request({
    url: "/admin/store/product/restore/".concat(id),
    method: 'get'
  });
}

/**
 * 商品列表 导出
 * @param pram
 */
export function productExcelApi(params) {
  var data = _objectSpread({}, params);
  var _ref5 = data.dateRange || [],
    _ref6 = _slicedToArray(_ref5, 2),
    startTime = _ref6[0],
    endTime = _ref6[1];
  if (startTime && endTime) {
    data['startTime'] = startTime;
    data['endTime'] = endTime;
  }
  ;
  if (data.showCateId) {
    data.showCateId = data.showCateId.join(',');
  }
  ;
  delete data.dateRange;
  return request({
    url: "/admin/export/excel/product",
    method: 'get',
    params: data
  });
}

/**
 * 商品列表 获取复制商品配置
 * @param pram
 */
export function copyConfigApi() {
  return request({
    url: "/admin/store/product/copy/config",
    method: 'post'
  });
}

/**
 * 订单数据 导出
 * @param pram
 */
export function orderExcelApi(params) {
  return request({
    url: "/admin/export/excel/order",
    method: 'get',
    params: params
  });
}

// 三方商品-----------------------------------------------------
/**
 * 京东商品列表
 */
export function thirdSkuLists() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var prams = _objectSpread({}, data);
  var _ref7 = prams.dataRenage || [],
    _ref8 = _slicedToArray(_ref7, 2),
    startTime = _ref8[0],
    endTime = _ref8[1];
  delete prams.dataRenage;
  prams = _objectSpread(_objectSpread({}, prams), {}, {
    startTime: startTime,
    endTime: endTime
  });
  return request({
    url: "/admin/fusiling/jd/goods/list",
    method: 'post',
    data: prams
  });
}

/**
 * 京东商品-导出
 */
export function exportJdGoods(data) {
  var inputNum = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
  var params = _objectSpread({}, data);
  delete params.page;
  delete params.limit;
  return request({
    url: "/admin/fusiling/jd/goods/export",
    method: 'post',
    data: _objectSpread(_objectSpread({}, params), {}, {
      inputNum: inputNum
    })
  });
}

/**
 * 京东商品-修改排序
 */
export function changeJdSort(params) {
  var goodsId = params.goodsId,
    sort = params.sort;
  return request({
    url: "/admin/fusiling/jd/goods/sort/".concat(goodsId, "/").concat(sort),
    method: 'POST',
    params: params
  });
}

/**
 * 京东商品-修改默认售价
 */
export function changeJdPrice(params) {
  var goodsId = params.goodsId,
    price = params.price;
  return request({
    url: "/admin/fusiling/jd/goods/price/".concat(goodsId, "/").concat(price),
    method: 'POST',
    params: params
  });
}

/**
 * 分页获取三方商品列表
 */
export function getThirdSkuList(data) {
  return request({
    url: "/admin/customer/third/sku/list",
    method: 'post',
    data: data
  });
}

/**
 * 导出三方商品列表
 */
export function exportThird(data) {
  var params = _objectSpread({}, data);
  delete params.page;
  delete params.limit;
  return request({
    url: "/admin/customer/third/sku/export",
    method: 'post',
    data: params
  });
}

/**
 * 导入三方商品列表
 */
export function importThirdGoods(data) {
  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return request({
    url: "/admin/customer/third/sku/import",
    method: 'post',
    data: data,
    params: params
  });
}

/**
 * 三方商品-改价
 */
export function changeThirdPrice(data) {
  return request({
    url: "/admin/customer/third/sku/price",
    method: 'put',
    data: data
  });
}

/**
 * 三方商品-修改状态
 */
export function changeThirdState(data) {
  return request({
    url: "/admin/customer/third/sku/status",
    method: 'put',
    data: data
  });
}

/**
 * 三方商品-同步商品信息
 */
export function syncThirdSku() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var prams = _objectSpread({}, data);
  var _ref9 = prams.dataRenage || [],
    _ref0 = _slicedToArray(_ref9, 2),
    startTime = _ref0[0],
    endTime = _ref0[1];
  delete prams.dataRenage;
  delete prams.page;
  delete prams.limit;
  prams = _objectSpread(_objectSpread({}, prams), {}, {
    startTime: startTime,
    endTime: endTime
  });
  return request({
    url: "/admin/fusiling/jd/goods/sync",
    method: 'get',
    data: prams
  });
}

/**
 * 展示商品
 */
export function getCompanyLists(data) {
  var datas = _objectSpread({}, data);
  if (datas.showCateIds && datas.showCateIds.length) {
    var lists = datas.showCateIds.map(function (item) {
      var lastIdId = item[item.length - 1];
      return lastIdId || '';
    }) || [];
    datas['showCateIds'] = lists.filter(function (item) {
      return item;
    });
  }
  ;
  return request({
    url: "/admin/show_product/list",
    method: 'post',
    data: datas
  });
}

/**
 * 全量同步
 */
export function syncProduct(data) {
  return request({
    url: "/admin/show_product/sync_data",
    method: 'post',
    data: data
  });
}

/**
 * 删除ShowProduct表数据后同步
 */
export function deleteAndSyncProduct(data) {
  return request({
    url: "/admin/show_product/sync_data",
    method: 'post',
    data: data
  });
}

/**
 * 保存修改
 */
export function getProductSave(data) {
  return request({
    url: "/admin/store/product/draft/save",
    method: 'post',
    data: data
  });
}

/**
 * 回显
 */
export function getProductSaveDetail(params) {
  return request({
    url: "/admin/store/product/draft/detail",
    method: 'get',
    params: params
  });
}

// 批量操作列表
export function batchList(params) {
  return request({
    url: "/admin/product/batch/list",
    method: 'get',
    params: params
  });
}

/**
 * 是否回显
 */
export function getProductSaveHasDraft(params) {
  return request({
    url: "/admin/store/product/draft/hasDraft",
    method: 'get',
    params: params
  });
}

/**
 * 是否删除回显
 */
export function getProductRemoveByProduct(id) {
  return request({
    url: "/admin/store/product/draft/removeByProduct?productId=".concat(id),
    method: 'post'
  });
}

// 获取上传文件nama
export function batchFileName(fileName) {
  return request({
    url: "/admin/product/batch/check/file?fileName=".concat(fileName),
    method: 'post'
  });
}

// 上传文件
export function batchTask(formData) {
  return request({
    url: "/admin/product/batch/add/task",
    method: 'post',
    data: formData,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  });
}

// 导出模板
export function batchTemplate(params) {
  return request({
    url: "/admin/product/batch/export/template",
    method: 'get',
    params: params
  });
}

// 查看日志
export function batchLogs(params) {
  return request({
    url: "/admin/product/batch/detail",
    method: 'get',
    params: params
  });
}

// 暂停/开始执行
export function batchTurnTask(batchId) {
  return request({
    url: "/admin/product/batch/turn/task?batchId=".concat(batchId),
    method: 'post'
  });
}

// 暂停/开始执行
export function batchTurnTaskList(params) {
  return request({
    url: "/admin/product/batch/detail/list",
    method: 'get',
    params: params
  });
}

// SKU图片上传
export function batchImage(data) {
  return request({
    url: "/admin/product/batch/sku/image",
    method: 'POST',
    data: data
  });
}

// 商品图片上传SPU
export function batchSpuImage(data) {
  return request({
    url: "/admin/product/batch/product/image",
    method: 'POST',
    data: data
  });
}

// 上架
export function batchPutOnShell(id) {
  return request({
    url: "/admin/store/product/putOnShell/".concat(id),
    method: 'get'
  });
}

// 下架
export function batchOffShellt(id) {
  return request({
    url: "/admin/store/product/offShell/".concat(id),
    method: 'get'
  });
}

//SKU下架
export function batchUpdateStatus(params) {
  return request({
    url: "/admin/store/sku/updateStatus",
    method: 'get',
    params: params
  });
}

//SKU采销状态
export function batchUpdateCpStatus(params) {
  return request({
    url: "/admin/store/sku/updateCpStatus",
    method: 'get',
    params: params
  });
}

//价格变动查询
export function priceAdjustmentLogApi(params) {
  return request({
    url: "/admin/store/product/price/log",
    method: 'get',
    params: params
  });
}

//价格变动查询-供应商
export function priceAdjustmentLogApi2(params) {
  return request({
    url: "/admin/supplier/product/price/log",
    method: 'get',
    params: params
  });
}

//提交审核
export function auditEditApi(data) {
  return request({
    url: "/admin/store/product/verify",
    method: 'POST',
    data: data
  });
}

// 一卡通库存管理 ---------------------------------------------
/**
 * 一卡通库存列表
 */
export function cardSkuLists() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return request({
    url: "/admin/onecard/sku/manage/list",
    method: 'GET',
    params: data
  });
}

/**
 * 一卡通库存 - 新增
 */
export function cardSkuAdd(data) {
  return request({
    url: "/admin/onecard/sku/manage",
    method: 'POST',
    data: data
  });
}

/**
 * 一卡通库存 - 删除
 */
export function cardSkuDelete(id) {
  return request({
    url: "/admin/card/sku/delete/".concat(id),
    method: 'DELETE'
  });
}

/**
 * 一卡通库存 - 平台下拉
 */
export function cardSkuPlatformOptions() {
  return request({
    url: "/admin/card/sku/platform/options",
    method: 'GET'
  });
}

/**
 * 一卡通库存 - 产品名称下拉
 */
export function cardSkuProductOptions() {
  return request({
    url: "/admin/onecard/sku/manage/options",
    method: 'GET'
  });
}

/**
 * 一卡通库存 - 卡类型下拉
 */
export function oneCardTypeOptions() {
  return request({
    url: "/admin/onecard/sku/manage/card-type/options",
    method: 'GET'
  });
}

/**
 * 一卡通库存 - 生成批次卡密商品下拉
 */
export function cardBatchSkuOptions() {
  return request({
    url: "/admin/onecard/batch/sku/options",
    method: 'GET'
  });
}

/**
 * 一卡通库存 - 生成批次卡密
 */
export function cardBatchGenerate(data) {
  return request({
    url: "/admin/onecard/batch/generate",
    method: 'POST',
    data: data
  });
}

/**
 * 一卡通库存 - 批次操作日志
 */
export function cardBatchLogPage() {
  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return request({
    url: "/admin/onecard/batch/logPage",
    method: 'GET',
    params: params
  });
}

/**
 * 一卡通库存 - 导出批次操作日志
 */
export function cardBatchLogExport() {
  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return request({
    url: "/admin/onecard/batch/exportLog",
    method: 'GET',
    params: params
  });
}

/**
 * 一卡通库存详情 - 实例卡分页
 */
export function cardInstanceCardPage() {
  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return request({
    url: "/admin/onecard/instanceCard/page",
    method: 'GET',
    params: params
  });
}

/**
 * 一卡通库存详情 - 导出实例卡
 */
export function cardInstanceCardExport() {
  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return request({
    url: "/admin/onecard/instanceCard/export",
    method: 'GET',
    params: params
  });
}

/**
 * 美景一卡通 - 导入卡号卡密
 */
export function oneCardMeijingImport(data, skuId) {
  return request({
    url: "/admin/onecard/instanceCard/import",
    method: 'POST',
    params: {
      skuId: skuId
    },
    data: data
  });
}

/**
 * 美景一卡通 - 下载导入模板
 */
export function downloadMeijingOneCardImportTemplate() {
  return request({
    url: '/admin/export/excel/template',
    method: 'GET',
    params: {
      fileName: 'mj_one_card_import_template.xlsx'
    }
  });
}

/**
 * 一卡通库存详情 - 实例卡使用详情
 */
export function cardInstanceUseDetail() {
  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return request({
    url: "/admin/onecard/instanceCard/useDetail",
    method: 'GET',
    params: params
  });
}

/**
 * 一卡通库存详情 - 权益使用记录
 */
export function cardRightUseRecord() {
  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return request({
    url: "/admin/onecard/instanceCard/rightUseRecord",
    method: 'GET',
    params: params
  });
}

/**
 * 一卡通库存详情 - 小程序下拉
 */
export function cardCustomerAppOptions() {
  return request({
    url: "/admin/customers/customer/app",
    method: 'GET'
  });
}

/**
 * 一卡通权益配置 - 分页列表
 */
export function oneCardRightConfigPage() {
  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return request({
    url: "/admin/onecard/rightConfig/page",
    method: 'GET',
    params: params
  });
}

/**
 * 一卡通权益配置 - 配置详情
 */
export function oneCardRightConfigDetail() {
  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return request({
    url: "/admin/onecard/rightConfig/detail",
    method: 'GET',
    params: params
  });
}

/**
 * 一卡通权益配置 - 可关联商品
 */
export function oneCardRightProductOptions() {
  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return request({
    url: "/admin/onecard/rightConfig/productOptions",
    method: 'GET',
    params: params
  });
}

/**
 * 一卡通权益配置 - 保存
 */
export function oneCardRightConfigSave(data) {
  return request({
    url: "/admin/onecard/rightConfig/save",
    method: 'POST',
    data: data
  });
}